import { describeError, problemErrorCode } from '@/lib/api';

/*
 * Recusas da API de feature flags com `errorCode` (change platform-backoffice-hardening,
 * H-10.2). O literal é o mesmo de `FeatureFlagErrorCodes`, no módulo Platform.FeatureFlags.
 * A tela mostra um motivo em pt-BR mesmo quando não sabia, pelo catálogo, que a flag era
 * kill switch (o catálogo falhou ou a aba ficou aberta durante o deploy).
 */
export const FEATURE_FLAG_ERROR_CODES = {
  killSwitchBinary: 'feature_flag.kill_switch_binary',
  killSwitchNotArchivable: 'feature_flag.kill_switch_not_archivable',
} as const;

const MESSAGES: Record<string, string> = {
  [FEATURE_FLAG_ERROR_CODES.killSwitchBinary]:
    'Esta flag é um kill switch: só liga ou desliga, para todas as lojas. Não aceita percentual de rollout (use vazio ou 100%), escopo por tenant nem override por tenant.',
  [FEATURE_FLAG_ERROR_CODES.killSwitchNotArchivable]:
    'Esta flag é um kill switch permanente e não pode ser arquivada. Para desligar, desmarque o default.',
};

/** Motivo legível de uma falha numa rota de feature flag; o resto cai em `describeError`. */
export function describeFeatureFlagError(err: unknown): string {
  const code = problemErrorCode(err);
  if (code && Object.hasOwn(MESSAGES, code)) return MESSAGES[code];
  return describeError(err);
}
